module.exports = __webpack_public_path__ + "static/media/critico-gastronomico.65c588bc.jpg";